import type { AddOnCatalogItem } from '@/types/addons';

// Global add-ons catalog; Montana-first mindset by keeping items relevant broadly,
// while allowing regions to have curated subsets (e.g., catalog.montana.ts)
export const GLOBAL_ADDONS_CATALOG: AddOnCatalogItem[] = [
  {
    id: 'analog-to-digital-assessment',
    name: 'Analog-to-Digital Assessment',
    shortLabel: 'Assessment',
    description:
      'Short scoping session and review to estimate the work for converting paper or unstructured files into organized digital records.',
    pricingModel: 'fixed-setup',
    price: 500,
    unit: 'setup',
    applicableTiers: ['silver', 'gold', 'custom'],
    badge: 'Scoped pre-signing',
  },
  {
    id: 'data-migration',
    name: 'Data Migration (Digital Organization)',
    shortLabel: 'Migration',
    description:
      'Organize and integrate your digital files into the platform. Pricing varies with volume and organization level.',
    pricingModel: 'quote',
    applicableTiers: ['silver', 'gold', 'custom'],
  },
  {
    id: 'governance-mirroring',
    name: 'Governance Mirroring Setup',
    shortLabel: 'Governance',
    description: 'Mirror boards, committees, cadence, and roles for a turnkey start.',
    pricingModel: 'quote',
    applicableTiers: ['silver', 'gold', 'custom'],
  },
  {
    id: 'sso-integration',
    name: 'Single Sign-On (SSO) Integration',
    shortLabel: 'SSO',
    description:
      'Tell us which identity provider your organization uses. We will scope feasibility and provide a quote before any work begins.',
    pricingModel: 'quote',
    applicableTiers: ['gold', 'custom'],
  },
  {
    id: 'custom-integrations',
    name: 'Custom Integrations',
    shortLabel: 'Integrations',
    description: 'Build integrations to your existing tools and systems.',
    pricingModel: 'quote',
    applicableTiers: ['silver', 'gold', 'custom'],
  },
];
